import * as React from 'react';

import { Divider, Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';
const QuestStepSkeleton = () => (
  <Box style={styles.step}>
    <Skeleton h="$13_5" w="$20" />
    <Skeleton.Text lines={2} flexShrink={1} />
  </Box>
);

const QuestIncentiveSkeleton = () => (
  <Box style={styles.incentive}>
    <Box style={styles.step}>
      <Skeleton h="$16" w="$16" rounded="full" />
      <Skeleton.Text lines={2} flexShrink={1} />
    </Box>
  </Box>
);

export const QuestDrawerSkeleton = () => (
  <Box style={styles.container}>
    <Skeleton.Text />
    <Box style={styles.details}>
      <Skeleton.Text lines={2} />
      <Box style={styles.steps}>
        <QuestStepSkeleton />
        <QuestStepSkeleton />
        <QuestStepSkeleton />
      </Box>
    </Box>
    <QuestIncentiveSkeleton />
    <Divider />
    <Skeleton.Text lines={4} />
  </Box>
);

const styles = StyleSheet.create({
  container: { gap: spacing.$6, padding: spacing.$4 },
  details: {
    backgroundColor: getDesignToken('background-default'),
    borderRadius: 12,
    gap: spacing.$8,
    padding: spacing.$4,
  },
  incentive: {
    backgroundColor: getDesignToken('background-default'),
    borderRadius: 12,
    padding: spacing.$4,
  },
  step: { alignItems: 'center', flexDirection: 'row', gap: spacing.$4, width: '100%' },
  steps: { gap: spacing.$2, padding: spacing.$2 },
});
